import request from '@/utils/request'

// 查询质量提升-标准服务-威海市地方标准列表
export function listZltsWhsdfbzgl(query) {
  return request({
    url: '/web/zlts/bzfw/zltsWhsdfbzgl/list',
    method: 'get',
    params: query
  })
}

// 查询质量提升-标准服务-威海市地方标准详细
export function getZltsWhsdfbzgl(recid) {
  return request({
    url: '/web/zlts/bzfw/zltsWhsdfbzgl/' + recid,
    method: 'get'
  })
}

// 下载pdf
export function downloadPdfStandard() {
  return request({
    url: '/web/zlts/bzfw/zltsWhsdfbzgl/downloadPdfStandard',
    method: 'get',
    responseType: 'blob', 
  })
}